<template>
  <div
    style="width: 100%; height: 100dvh;"
    class="d-flex flex-column align-center justify-center"
  >
    <div
      class="d-flex"
      style="width: 200px; position: absolute; top: 0; left: 0; margin: 20px;"
    >
      <img
        v-if="isThemeDark"
        src="@/assets/logo-dark.svg"
        width="100%"
        alt="logo"
        height="100%"
      />

      <img
        v-else
        src="@/assets/logo.svg"
        width="100%"
        alt="logo"
        height="100%"
      />
    </div>
    <div
      class="d-flex flex-column align-center justify-center"
      style="width: 500px"
    >
      <img
        src="@/assets/not_found.svg"
        alt="Pedlook"
        class="mb-6"
      />

      <h1 class="mb-4">
        Página não encontrada!
      </h1>
      <p style="text-align: center">
        Nós lamentamos, mas a página que você procura não foi encontrada<br>
      </p>

      <base-button class="mt-2 pl-4 pr-4" @click="() => router.replace(useUseRouteCallbackUrl('/home'))">
        <span>Voltar para tela inicial</span>
      </base-button>
    </div>
  </div>
</template>

<script setup lang="ts">
const isThemeDark  = false

const router = useRouter();
</script>

<style lang="scss" scoped>

</style>
